// extracted by mini-css-extract-plugin
export var fullGrid = "_29-3";
export var pdpPreviewContainer = "_29-1";
export var previewContainer = "_29-0";
export var togglePreviewContainer = "_29-2";